module.exports = __webpack_public_path__ + "img/Freelance_boja_negativ.201c6a8.svg";